module.exports = __webpack_public_path__ + "static/media/71Ir0ifwH+L._AC_SL1500_.49b78844.jpg";